// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"e326c566e0469c00ddc9","655":"542cd0654cc7e05c2dcc"}[chunkId] + ".js";
};